import { apiGet } from '../api/apiClient';
import { API_ENDPOINTS } from '@/constants/endpoints';

export interface Report {
  _id: string;
  feedId: {
    _id: string;
    content: string;
    title: string;
  };
  reportedBy: {
    _id: string;
    name: string;
    email: string;
  };
  reason: string;
  createdAt: string;
  updatedAt: string;
}

export interface ReportsResponse {
  success: boolean;
  message: string;
  data: {
    reports: Report[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalItems: number;
      itemsPerPage: number;
      hasNext: boolean;
      hasPrev: boolean;
    };
  };
}

export interface ReportParams {
  page?: number;
  limit?: number;
}

class ReportService {
  async getReports(params?: ReportParams): Promise<ReportsResponse> {
    try {
      const queryParams: Record<string, string> = {};

      if (params?.page) queryParams.page = params.page.toString();
      if (params?.limit) queryParams.limit = params.limit.toString();

      const queryString = new URLSearchParams(queryParams).toString();
      const url = queryString ? `${API_ENDPOINTS.FEED.REPORT}?${queryString}` : API_ENDPOINTS.FEED.REPORT;

      return await apiGet<ReportsResponse>(url);
    } catch (error: any) {
      throw error.response?.data || { message: 'Failed to fetch reports' };
    }
  }
}

export const reportService = new ReportService();
